import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { NormaService } from '../../services/norma.service'
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { GlobalsConstants } from '../../commons/global-constants';

declare var $: any;

@Component({
  selector: 'app-norma',
  templateUrl: './norma.component.html',
})
export class NormaComponent implements OnInit {
  titulo = "Normatividad";
    requiredType = "2";
    reportUrl: string;


    constructor(private globals: GlobalsConstants, private normaService: NormaService, private activatedRoute: ActivatedRoute){}
    ngOnInit() {
        this.normaService.fileExportarNorma().subscribe(
            response => {
                setTimeout(() => {
                    let status: any = { estado: false, detalle: "" }
                    status = response;
                    let fileAddress = this.globals.SERVER_address + response;
                    this.reportUrl = fileAddress;
                }, 1500);
            },
            err => {
                console.error(err)
            }
        )
        document.documentElement.scrollTop = 0;

    }


    fileExportarNorma() {
        this.normaService.fileExportarNorma().subscribe(
            response => {
                setTimeout(() => {
                    let status: any = { estado: false, detalle: "" }
                    status = response;
                    let fileAddress = this.globals.SERVER_address + response;
                    console.log(fileAddress);

                    this.reportUrl = fileAddress;
                    window.open(fileAddress, '_blank');
                }, 1500);
            },
            err => {
                console.error(err)
            }
        )
    }

}
